import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-font-2",
  "use": "icon-font-2-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-font-2\"><path d=\"M367.0016 42.66666666H532.48l367.0016 952.832H743.3216l-89.3952-245.5552H244.224l-89.3952 245.5552H0L367.0016 42.66666666z m-78.7456 587.1616h321.536l-157.3888-431.104h-5.3248l-158.72 431.104zM972.8 198.31466666V44.71466666h102.4v153.6H1228.8v102.4h-153.6v153.6h-102.4v-153.6H819.2v-102.4h153.6z\" fill=\"currentColor\" p-id=\"5404\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/font-2.svg
// module id = LeBg
// module chunks = 3